import moment from "moment";

export class Event {
  EngEventTitle;
  ChiEventTitle;
  EventCode;
  EventDesc;
  EventLoc;
  WorkType;
  Local;
  EventDates;
  UsersList;
  EventFinished;
  DateAdd;
  AddBy;
  DateModify;
  ModifyBy;
  RecDel;
  FromTime;
  ToTime;
  SupervisorID;
  constructor() {
    this.EngEventTitle = "";
    this.ChiEventTitle = "";
    this.EventCode = "";
    this.EventDesc = "";
    this.EventLoc = "";
    this.WorkType = "";
    this.Local = "Local";
    this.EventDates = [];
    this.UsersList = [];
    this.EventFinished = false;
    this.DateAdd = moment(new Date()).format("YYYY-MM-DD");
    this.AddBy = "";
    this.DateModify = moment(new Date()).format("YYYY-MM-DD");
    this.ModifyBy = "";
    this.RecDel = "";
    this.FromTime = "";
    this.ToTime = "";
    this.SupervisorID = "";
  }
}



// WEBPACK FOOTER //
// ./src/model/Event.js